var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.option.isHidden)?_c('div',[_c('AiGuide',{attrs:{"all":_vm.all,"showName":_vm.candidate.showName,"mindData":_vm.mindData,"pdfIng":_vm.pdfIng,"pdfPsycGuide":_vm.pdfPsycGuide}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }